export default __webpack_public_path__ + "static/media/download.5524f1a7.svg";